export default {
    rewards: [
        { position: 1, reward: { daily: 30, weekly: 60, monthly: 120,  currency: "DMD"}},
        { position: 2, reward: { daily: 15, weekly: 30, monthly: 60,  currency: "DMD"}},
        { position: 3, reward: { daily: 8, weekly: 15, monthly: 30,  currency: "DMD"}},
        { position: 4, reward: { daily: 4, weekly: 8, monthly: 15,  currency: "DMD"}},
        { position: 5, reward: { daily: 4, weekly: 8, monthly: 15,  currency: "DMD"}},
        { position: 6, reward: { daily: 4, weekly: 8, monthly: 15,  currency: "DMD"}},
        { position: 7, reward: { daily: 4, weekly: 8, monthly: 15,  currency: "DMD"}},
        { position: 8, reward: { daily: 4, weekly: 8, monthly: 15,  currency: "DMD"}},
        { position: 9, reward: { daily: 4, weekly: 8, monthly: 15,  currency: "DMD"}},
        { position: 10, reward: { daily: 4, weekly: 8, monthly: 15,  currency: "DMD"}},
        { position: 11, reward: { daily: 2500, weekly: 5000, monthly: 10000,  currency: "coin"}},
        { position: 12, reward: { daily: 2500, weekly: 5000, monthly: 10000,  currency: "coin"}},
        { position: 13, reward: { daily: 2500, weekly: 5000, monthly: 10000,  currency: "coin"}},
        { position: 14, reward: { daily: 2500, weekly: 5000, monthly: 10000,  currency: "coin"}},
        { position: 15, reward: { daily: 2500, weekly: 5000, monthly: 10000,  currency: "coin"}},
        { position: 16, reward: { daily: 1000, weekly: 2500, monthly: 5000,  currency: "coin"}},
        { position: 17, reward: { daily: 1000, weekly: 2500, monthly: 5000,  currency: "coin"}},
        { position: 18, reward: { daily: 1000, weekly: 2500, monthly: 5000,  currency: "coin"}},
        { position: 19, reward: { daily: 1000, weekly: 2500, monthly: 5000,  currency: "coin"}},
        { position: 20, reward: { daily: 1000, weekly: 2500, monthly: 5000,  currency: "coin"}},
    ]
}